<ng-container [formGroup]="$any(controlContainer?.control)">
    <wdx-form-field
        [locked]="formElement?.isLocked"
        [label]="formElement?.label | translateTokenisedString"
        [guidanceText]="formElement?.guidanceText | translateTokenisedString"
        [isSensitive]="formElement?.isSensitive ?? undefined"
        [isRequired]="formElement?.isRequired ?? undefined"
        [labelForId]="inputId"
        [validationErrorMessage]="
            (formControl?.touched
                ? formControl?.errors ||
                  (numberControl?.touched ? numberControl?.errors : null)
                : null
            ) | validationErrorMessage
        "
        [warningMessage]="warningText"
    >
        <div class="input-group" [formGroup]="telephoneFormGroup">
            <ng-select
                #countrySelect
                formControlName="country"
                bindLabel="name"
                bindValue="isoCode"
                [attr.data-cy]="'dropdown-telephone-' + formElement?.label"
                [clearable]="false"
                [readonly]="
                    isDisabled ||
                    PENDING_CHANGES_LOCK_FIELD.includes(
                        $any(formElement?.pendingChange?.status)
                    )
                "
            >
                @for (
                    option of countries$ | ngrxPush;
                    track $index;
                    let index = $index
                ) {
                    <ng-option
                        attr.data-cy="option-country"
                        [value]="option.isoCode"
                    >
                        <span class="d-flex align-items-center">
                            <span
                                [attr.data-cy]="
                                    'telephone-iso-code-' + formElement.name
                                "
                                class="flag flag-{{
                                    option?.isoCode | lowercase
                                }} me-1"
                            ></span>
                            <span
                                [attr.data-cy]="
                                    'telephone-country-name-' + formElement.name
                                "
                                class="hide-on-trigger ms-1"
                                >{{ option.name }}</span
                            >
                            <span
                                class="text-muted mx-1"
                                [attr.data-cy]="
                                    'telephone-dial-code-' + formElement.name
                                "
                            >
                                {{ option.dialCode }}
                            </span>
                        </span>
                    </ng-option>
                }
            </ng-select>
            <input
                wdxInputText
                formControlName="number"
                type="tel"
                inputmode="tel"
                [mask]="mask"
                [attr.id]="inputId"
                [attr.data-cy]="'input-' + formElement.name"
                [attr.maxlength]="formElement.max || 35"
                [attr.readonly]="
                    isDisabled ||
                    PENDING_CHANGES_LOCK_FIELD.includes(
                        $any(formElement?.pendingChange?.status)
                    ) ||
                    null
                "
            />
            @if (fieldDefOptions$ | ngrxPush; as options) {
                @if (options.length > 1) {
                    <ng-select
                        formControlName="type"
                        bindLabel="label"
                        bindValue="value"
                        placeholder="Select"
                        data-cy="select-type"
                        [items]="options"
                        [searchable]="false"
                        [clearable]="false"
                        [readonly]="
                            isDisabled ||
                            PENDING_CHANGES_LOCK_FIELD.includes(
                                $any(formElement?.pendingChange?.status)
                            )
                        "
                    >
                    </ng-select>
                }
                @if (options.length === 1) {
                    <div
                        class="input-group-text"
                        [attr.data-cy]="'telephone-fixed-type'"
                    >
                        {{ options[0]?.label }}
                    </div>
                }
            }
        </div>
    </wdx-form-field>
</ng-container>
